import { trigger, animate, style, transition, keyframes, query, stagger, state } from '@angular/animations';
import { AnimationController } from '@ionic/angular';

export const DOCKET_LAYOUT_FADE_IN = trigger('stagger', [
  transition('* => *', [
    query(':enter', [style({ opacity: 0 }), stagger(50, [animate('0.2s', style({ opacity: 1 }))])], { optional: true }),
  ]),
]);

export const FADE_ENTER = trigger('fadeEnter', [
  transition('* => *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translate3d(100px,0,0)' }),
        animate('2s ease-in-out', style({ opacity: 1, transform: 'translate3d(0,0,0)' })),
      ],
      { optional: true },
    ),
  ]),
]);

export const SLIDE_UP_FROM_BELOW = trigger('slideUpFromBelow', [
  state(
    'show',
    style({
      transform: 'translate3d(0, -100%, 0)',
      opacity: 1,
    }),
  ),

  state(
    'hide',
    style({
      transform: 'translate3d(0, 0, 0)',
      opacity: 0,
    }),
  ),

  transition('hide <=> show', [animate('.4s ease-in-out')]),
]);

export const SLIDE_UP = trigger('slideUp', [
  state(
    'blur',
    style({
      transform: 'translate3d(0, 0, 0)',
    }),
  ),
  state(
    'focus',
    style({
      transform: 'translate3d(0, {{yPos}}px, 0)',
    }),
    { params: { yPos: 0 } },
  ),
  transition('blur <=> focus', [animate('.1s linear')]),
]);

// PAGE NAVIGATION
const animationCtrl = new AnimationController();
export const getIonPageElement = (element: HTMLElement) => {
  if (element.classList.contains('ion-page')) {
    return element;
  }

  const ionPage = element.querySelector(':scope > .ion-page, :scope > ion-nav, :scope > ion-tabs');
  if (ionPage) {
    return ionPage;
  }
  // idk, return the original element so at least something animates and we don't have a null pointer
  return element;
};
export const fancyAnimation = (_: HTMLElement, opts: any) => {
  const backDirection = opts.direction === 'back';
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;

  const enteringPageEl = getIonPageElement(enteringEl);

  const rootTransition = animationCtrl.create();

  const enterTransition = animationCtrl.create();
  const leavingTransition = animationCtrl.create();

  leavingTransition.addElement(getIonPageElement(leavingEl)).duration(250);

  enterTransition.addElement(enteringPageEl).duration(600).fill('both').beforeRemoveClass('ion-page-invisible');

  if (!backDirection) {
    enterTransition.keyframes([
      { offset: 0, opacity: 0.1 },
      { offset: 1, opacity: 1 },
    ]);

    leavingTransition.keyframes([
      { offset: 0, opacity: 1 },
      { offset: 1, opacity: 0.1 },
    ]);
  } else {
    enterTransition.keyframes([
      { offset: 0, opacity: 0.1 },
      { offset: 1, opacity: 1 },
    ]);

    leavingTransition.keyframes([
      { offset: 0, opacity: 1 },
      { offset: 1, opacity: 0 },
    ]);
  }

  rootTransition.addAnimation([enterTransition, leavingTransition]);

  return rootTransition;
};

export const modalEnterAnimation = (baseEl: any) => {
  const backdropAnimation = animationCtrl
    .create()
    .addElement(baseEl.querySelector('ion-backdrop')!)
    .fromTo('opacity', '0.01', '0.9')
    .duration(500);

  const wrapperAnimation = animationCtrl
    .create()
    .addElement(baseEl.querySelector('.modal-wrapper')!)
    .delay(0)
    .keyframes([
      { offset: 0, opacity: '0', transform: 'scale(0)' },
      { offset: 1, opacity: '0.99', transform: 'scale(1)' },
    ])
    .duration(500);

  return animationCtrl
    .create()
    .addElement(baseEl)
    .easing('ease-out')
    .addAnimation([backdropAnimation, wrapperAnimation]);
};
export const modalLeaveAnimation = (baseEl: any) => {
  return modalEnterAnimation(baseEl).direction('reverse');
};
